import { render, staticRenderFns } from "./ot_desc.vue?vue&type=template&id=5b1d0671&scoped=true&"
import script from "./ot_desc.vue?vue&type=script&lang=js&"
export * from "./ot_desc.vue?vue&type=script&lang=js&"
import style0 from "./ot_desc.vue?vue&type=style&index=0&id=5b1d0671&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d0671",
  null
  
)

export default component.exports